var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensivoR3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285,
    height: 128,
    viewBox: "0 0 285 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c21fd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1679",
    "data-name": "Ret\\xE2ngulo 1679",
    width: 45.908,
    height: 16.514,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1684",
    "data-name": "Ret\\xE2ngulo 1684",
    width: 276.309,
    height: 63.893,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3894",
    "data-name": "Grupo 3894",
    transform: "translate(-1369 -930)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1668",
    "data-name": "Ret\\xE2ngulo 1668",
    width: 285,
    height: 128,
    transform: "translate(1369 930)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3906",
    "data-name": "Grupo 3906",
    transform: "translate(1372 962.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3907",
    "data-name": "Grupo 3907",
    transform: "translate(230.401 46.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3906-2",
    "data-name": "Grupo 3906",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1678",
    "data-name": "Ret\\xE2ngulo 1678",
    width: 45.908,
    height: 16.514,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1680",
    "data-name": "Ret\\xE2ngulo 1680",
    width: 45.86,
    height: 44.457,
    transform: "translate(230.448 0.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1736",
    "data-name": "Caminho 1736",
    d: "M0,1.147v29.4H22.118V23.523H8.852v-4.8H19.576V12.2H8.852V7.931H22.118V1.147Z",
    transform: "translate(0 -0.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1737",
    "data-name": "Caminho 1737",
    d: "M85.462,1.147,76.917,14.783l9.9,15.761h-10.5L70.89,21.287l-5.479,9.257H57.153l9.469-15.179L57.541,1.147H68.066l4.561,7.911L77.36,1.147Z",
    transform: "translate(-34.61 -0.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1738",
    "data-name": "Caminho 1738",
    d: "M145.466,8.19V30.544h-8.55V8.19h-6.095V1.147h20.739V8.19Z",
    transform: "translate(-79.221 -0.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1739",
    "data-name": "Caminho 1739",
    d: "M212.017,23.523v7.021H189.9V1.148h22.118V7.931H198.75V12.2h10.725v6.526H198.75v4.8Z",
    transform: "translate(-114.996 -0.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3909",
    "data-name": "Grupo 3909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3908",
    "data-name": "Grupo 3908",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1740",
    "data-name": "Caminho 1740",
    d: "M280.17,30.544h-7.344l-8.051-12.988a49.5,49.5,0,0,1-3.126-6.071,20.466,20.466,0,0,1,.711,4.824V30.544h-7.322V1.147h8.528l6.849,10.767a41.533,41.533,0,0,1,3.1,5.643,42.73,42.73,0,0,1-.689-7.71v-8.7h7.344Z",
    transform: "translate(-154.442 -0.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1741",
    "data-name": "Caminho 1741",
    d: "M324.051,21.342l8.377-1.508q1.055,3.553,5.427,3.553,3.4,0,3.4-1.809a1.678,1.678,0,0,0-.786-1.475,8.44,8.44,0,0,0-2.811-.936q-7.732-1.482-9.929-3.873a8.044,8.044,0,0,1-2.2-5.623,8.8,8.8,0,0,1,3.155-6.915Q331.847,0,337.769,0q8.981,0,11.867,7.215l-7.473,2.261a4.572,4.572,0,0,0-4.717-2.95q-2.951,0-2.95,1.831a1.448,1.448,0,0,0,.668,1.271,8.169,8.169,0,0,0,2.585.86,54.678,54.678,0,0,1,7.5,1.975,8.075,8.075,0,0,1,3.7,2.938,8.214,8.214,0,0,1,1.485,4.9,8.687,8.687,0,0,1-3.618,7.231,15.209,15.209,0,0,1-9.5,2.769q-10.747,0-13.266-8.959",
    transform: "translate(-196.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1681",
    "data-name": "Ret\\xE2ngulo 1681",
    width: 9.023,
    height: 29.397,
    transform: "translate(157.645 0.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1742",
    "data-name": "Caminho 1742",
    d: "M457.273,1.147l-9.122,29.4h-9.2l-9.539-29.4h9.509l4.652,16.023q.476,1.422.844,2.8l5.432-18.822Z",
    transform: "translate(-260.039 -0.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1743",
    "data-name": "Caminho 1743",
    d: "M515.576,30.3a13.319,13.319,0,0,1-10.111-4.114q-3.91-4.113-3.909-11A15.989,15.989,0,0,1,505.293,4.3Q509.029,0,515.662,0a13.212,13.212,0,0,1,10,4.049q3.865,4.049,3.866,10.811,0,7-3.9,11.22A13.069,13.069,0,0,1,515.576,30.3m-.043-6.676a3.412,3.412,0,0,0,3.284-1.992q1-1.992,1-7.29,0-7.667-4.114-7.667-4.436,0-4.437,8.743,0,8.206,4.265,8.205",
    transform: "translate(-303.725 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1744",
    "data-name": "Caminho 1744",
    d: "M23.1,92.229v27.1H14.786V108.786H8.434v10.542H.115v-27.1H8.434v9.966h6.353V92.229Z",
    transform: "translate(-0.07 -55.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1745",
    "data-name": "Caminho 1745",
    d: "M81.848,119.327l-1.532-5.34H73.057l-1.627,5.34H64.677l8.366-27.1h8.794l8.5,27.1Zm-7.377-11.256h4.384l-2.192-7.861Z",
    transform: "translate(-39.166 -55.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1746",
    "data-name": "Caminho 1746",
    d: "M160.179,119.327h-9.221L147,108.964h-2.623v10.363h-8.318v-27.1h14.154q4.685,0,7.276,2.193a7.211,7.211,0,0,1,2.591,5.787,8.7,8.7,0,0,1-.953,4.139,8.02,8.02,0,0,1-3.851,3.166Zm-15.8-16.16h3.553a4.373,4.373,0,0,0,2.521-.655,2.186,2.186,0,0,0,.953-1.926q0-2.6-3.2-2.6h-3.832Z",
    transform: "translate(-82.393 -55.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1747",
    "data-name": "Caminho 1747",
    d: "M207.175,119.327v-27.1h10.482q6.829,0,10.224,4.05a14.155,14.155,0,0,1,3.395,9.37,13.684,13.684,0,0,1-3.643,9.876,12.511,12.511,0,0,1-9.459,3.8Zm8.318-6.234h2.164a4.17,4.17,0,0,0,3.484-2,9.3,9.3,0,0,0,1.42-5.459,9.892,9.892,0,0,0-1.261-5.1,4,4,0,0,0-3.643-2.144h-2.164Z",
    transform: "translate(-125.458 -55.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1748",
    "data-name": "Caminho 1748",
    d: "M307.931,92.229l-7.187,27.1h-6.988l-3.791-14.949-3.579,14.949H279.1l-7.2-27.1h7.827l3.791,15.6,3.7-15.6h6.531l4.022,15.627,3.8-15.627Z",
    transform: "translate(-164.653 -55.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1749",
    "data-name": "Caminho 1749",
    d: "M378.136,119.1a12.279,12.279,0,0,1-9.32-3.792q-3.6-3.791-3.6-10.144a14.738,14.738,0,0,1,3.444-10.035q3.444-3.961,9.559-3.961a12.178,12.178,0,0,1,9.221,3.732Q391,98.637,391,104.871q0,6.452-3.593,10.343a12.046,12.046,0,0,1-9.271,3.891m-.04-6.154a3.144,3.144,0,0,0,3.027-1.836q.924-1.836.923-6.72,0-7.067-3.792-7.067-4.09,0-4.09,8.06,0,7.564,3.931,7.564",
    transform: "translate(-221.16 -55.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1750",
    "data-name": "Caminho 1750",
    d: "M463.62,119.327H454.4l-3.958-10.363h-2.623v10.363H439.5v-27.1h14.154q4.685,0,7.276,2.193a7.211,7.211,0,0,1,2.591,5.787,8.7,8.7,0,0,1-.953,4.139,8.02,8.02,0,0,1-3.851,3.166Zm-15.8-16.16h3.553a4.373,4.373,0,0,0,2.521-.655,2.186,2.186,0,0,0,.953-1.926q0-2.6-3.2-2.6h-3.832Z",
    transform: "translate(-266.146 -55.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1751",
    "data-name": "Caminho 1751",
    d: "M535.054,119.327h-9.1l-4.685-10.24-2.81,3.987v6.253h-7.842v-27.1h7.842v11.2l7.473-11.2h7.476l-6.844,9.918Z",
    transform: "translate(-309.211 -55.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1752",
    "data-name": "Caminho 1752",
    d: "M596.731,133.553a2.444,2.444,0,0,1-2.741,2.781q-2.733,0-2.734-2.781v-8.08a2.738,2.738,0,1,1,5.475,0V128.7h-1.906v-3.232q0-.889-.828-.9h-.013q-.822,0-.822.9v8.08q0,.9.828.9t.835-.9v-2.148h1.906Z",
    transform: "translate(-358.044 -74.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1753",
    "data-name": "Caminho 1753",
    d: "M609.063,136.44V123.228h1.906v11.333h3.037v1.879Z",
    transform: "translate(-368.827 -74.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1682",
    "data-name": "Ret\\xE2ngulo 1682",
    width: 1.906,
    height: 13.212,
    transform: "translate(246.357 48.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1754",
    "data-name": "Caminho 1754",
    d: "M633.937,123.228h1.569l2.067,3.637v-3.637h1.838V136.44h-1.838V130.3l-1.8-3.232v9.374h-1.838Z",
    transform: "translate(-383.89 -74.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1683",
    "data-name": "Ret\\xE2ngulo 1683",
    width: 1.906,
    height: 13.212,
    transform: "translate(257.306 48.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1755",
    "data-name": "Caminho 1755",
    d: "M666.83,133.553a2.444,2.444,0,0,1-2.741,2.781q-2.733,0-2.734-2.781v-8.08a2.738,2.738,0,1,1,5.475,0V128.7h-1.906v-3.232q0-.889-.828-.9h-.013q-.822,0-.822.9v8.08q0,.9.828.9t.835-.9v-2.148h1.906Z",
    transform: "translate(-400.494 -74.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1756",
    "data-name": "Caminho 1756",
    d: "M679.888,133.746l-.343,2.694h-1.919l1.966-13.212h2.613l1.96,13.212h-1.926l-.343-2.694Zm1.778-1.818-.774-6.141-.775,6.141Z",
    transform: "translate(-410.347 -74.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1757",
    "data-name": "Caminho 1757",
    d: "M608.514,36.035l5.619,10.95h-5.945l-4.833-9.972h-.748v9.972h-5.427V9.36h7.9q7.229.02,7.23,7.92V29.093q0,4.986-3.8,6.942m-5.906-21.344V31.835h1.246a5.23,5.23,0,0,0,1.553-.153,2.329,2.329,0,0,0,1.477-2.4V17.261q0-2.57-2.359-2.57Z",
    transform: "translate(-361.632 -5.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1758",
    "data-name": "Caminho 1758",
    d: "M658.1,15.754q0-2.531-2.359-2.55H655.7q-2.34,0-2.34,2.55V20.8h-5.427V15.754q0-7.9,7.786-7.9,7.805,0,7.805,7.9v5.389q0,4.852-3.356,6.386,3.355,1.534,3.356,6.386v4.852q0,7.9-7.805,7.9-7.786,0-7.786-7.9V33.722h5.427v5.044q0,2.551,2.34,2.55h.038q2.359-.019,2.359-2.55V33.914q0-3.777-3.433-3.777h-1.016V24.786h1.438q3.01,0,3.011-3.682Z",
    transform: "translate(-392.369 -4.756)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensivoR3);
export default __webpack_public_path__ + "static/media/extensivoR3.9a8e4314e2df1d2c3fa6e47f235e415e.svg";
export { ForwardRef as ReactComponent };